import { getStorage, ref, uploadBytes } from 'firebase/storage'
import { kGcsUserFileUploadsBucketRef } from '@/constants/constants-gcs'
import { isValidUserFolderPath } from './validate-folder-path'

export async function createNewFolder(folderPath: string, folderName: string): Promise<void> {
  const storage = getStorage(undefined, kGcsUserFileUploadsBucketRef)
  const newFolderPath = `${folderPath}/${folderName}`

  if (!isValidUserFolderPath(folderPath)) {
    throw new Error('Invalid folder path: must follow pattern users/[UUID]/...')
  }

  const placeholderRef = ref(storage, `${newFolderPath}/.keep`)
  const emptyBlob = new Blob([''], { type: 'text/plain' })

  await uploadBytes(placeholderRef, emptyBlob)
}
